import React from "react"
import { BundleOutcome, OrderLine } from "lib/types/generated/graphql-types"
import {
  Container,
  ImageAndDetails,
  ImageContainer,
  OrderlineName,
  ProductImage,
  ProductInfo
} from "./Bundle.styled"
import Bundle from "./Bundle"
import { handleImageError } from "helpers/image"

type BundleOrderLine = {
  orderLine: OrderLine
  bundles: BundleOutcome[]
}

type Props = {
  bundleOrderLine: BundleOrderLine | undefined
  currencyCode: string
}

export const BundleDiscount = ({ bundleOrderLine, currencyCode }: Props) => {
  if (!bundleOrderLine) return null

  const { orderLine } = bundleOrderLine

  return (
    <Container key={orderLine.id}>
      <ImageAndDetails>
        <ImageContainer>
          <ProductImage src={orderLine.imageUrl as string} onError={handleImageError} />
        </ImageContainer>
        <ProductInfo>
          <OrderlineName>{orderLine.displayName}</OrderlineName>
          <b>Id: </b>
          {orderLine.productVariantId} | <b>Parent Id:</b> {orderLine.productParentId}|{" "}
          <b>Quantity:</b> {orderLine.quantity}
        </ProductInfo>
      </ImageAndDetails>
      {bundleOrderLine?.bundles?.map((bundle) => (
        <Bundle key={bundle.bundleId} bundle={bundle} currencyCode={currencyCode} />
      ))}
    </Container>
  )
}

export default BundleDiscount
